import gql from "graphql-tag";

export const DeleteSpecificObjective = gql`
  mutation DeleteSpecificObjective($id: [String!]!) {
    deleteSpecificObjectives(ids: $id)
  }
`;
